import NextImage from 'next/legacy/image'
import { useState, type FunctionComponent } from 'react'
import { Translation, useTranslate } from '../../contexts/TranslationContext'
import { Button } from '../shared/Button'
import { Container } from '../shared/Container'
import { Hidden } from '../shared/Hidden'
import { SuggestionModal } from '../shared/SuggestionModal'
import style from './EndOfListBanner.module.sass'

export const EndOfListBanner: FunctionComponent = () => {
	const [isModalOpen, setIsModalOpen] = useState(false)

	const translate = useTranslate()

	return (
		<Container size="narrow">
			<div className={style.wrapper}>
				<SuggestionModal isModalOpen={isModalOpen} handleClose={() => setIsModalOpen(false)} />

				<div className={style.content}>
					<div className={style.header}>
						<div className={style.title}>
							<Translation tr="endOfListBanner.title" />
						</div>
					</div>
					<div className={style.subtitle}>
						<span>
							<Translation tr="endOfListBanner.subtitle" />
						</span>
					</div>
					<Hidden breakpoint="mobileDown">
						<div className={style.buttonWrapper}>
							<Button label={translate('endOfListBanner.button.contactUs')} onClick={() => setIsModalOpen(true)} />
						</div>
					</Hidden>
				</div>
				<div className={style.imageWrapper}>
					<NextImage
						src="/images/endOfListDog.png"
						alt={translate('endOfListBanner.alt.image')}
						title={translate('endOfListBanner.alt.image')}
						layout="fill"
						objectFit="cover"
					/>
				</div>
				<Hidden breakpoint="mobileUp">
					<div className={style.buttonWrapper}>
						<Button label={translate('endOfListBanner.button.contactUs')} onClick={() => setIsModalOpen(true)} />
					</div>
				</Hidden>
				<button
					onClick={() => setIsModalOpen(true)}
					className={style.dimensionsButton}
					aria-label={translate('endOfListBanner.button.contactUs')}
				/>
			</div>
		</Container>
	)
}
